export interface SeoImage {
  url: string;
  alt: string;
  width: number;
  height: number;
}

export const FALLBACK_SEO_IMAGE = { url: "/images/og-default.jpg", width: 1200, height: 630 };

export const SEO_MAP_IMAGE_SIZE = { width: 1200, height: 630 };

export function seoImageFrom(image: { url: string; width: number; height: number } | null | undefined, alt: string): SeoImage | null {
  return image ? { url: image.url, alt, width: image.width, height: image.height } : null;
}
